(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dd-loyalty-points"] && !Shopify.designMode) return;
  try {
    class DDLoyaltyPoints extends HTMLElement {
    connectedCallback() {
      // Normalize the server-rendered number so its formatting matches updates
      // (no movement on load — formatting only).
      this.format(this.pointsEl());

      this.section = this.closest('.shopify-section, dialog');
      this.section?.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    pointsEl() {
      return this.querySelector('[ref="points"]');
    }

    format(el) {
      if (!el) return;
      const value = parseInt(el.dataset.value || '0', 10);
      el.textContent = value.toLocaleString();
    }

    onVariantUpdate = (event) => {
      const data = event.detail?.data;
      if (!data?.html) return;

      // Combined listings can swap the underlying product.
      if (data.newProduct) {
        this.dataset.productId = data.newProduct.id;
      } else if (data.productId && data.productId !== this.dataset.productId) {
        return;
      }

      const fresh = data.html.querySelector(
        `dd-loyalty-points[data-block-id="${this.dataset.blockId}"]`
      );
      if (!fresh) return;

      const from = parseInt(this.pointsEl()?.dataset.value || '0', 10);
      this.innerHTML = fresh.innerHTML;
      this.countUp(from);
    };

    // Standout micro-interaction: the points value tweens to the new variant's
    // total. Triggered only by user intent (variant change), never on load.
    countUp(from) {
      const el = this.pointsEl();
      if (!el) return;

      const to = parseInt(el.dataset.value || '0', 10);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || from === to) {
        el.textContent = to.toLocaleString();
        return;
      }

      const duration = 240;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 2); // easeOutQuad — snappier finish
        el.textContent = Math.round(from + (to - from) * eased).toLocaleString();
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('dd-loyalty-points')) {
    customElements.define('dd-loyalty-points', DDLoyaltyPoints);
  }
  } catch(e) { console.error(e); }
})();

})();
